<script>
  import { onMount } from "svelte";

  import Stats from "./stats.svelte";
  import { updateLogs } from '../utils.js';
  import { contractEvents } from '../db.js';

  /** @type {number} */
  export let chain;
  /** @type {string} */
  export let address;
  export let loading;

  const pieConf = {
    donut: true,
    width: 400,
    key: { field: 'wallet', type: 'wallet' },
    value: { field: 'amount', type: 'wei', repr: 'ether' }
  }

  const columns = [
    { type: 'color', key: 'wallet' },
    { type: 'wallet', key: 'wallet', compact: 4 },
    { type: 'nativeEther', key: 'amount' },
  ]

  let transfers;

  let data;

  $: $transfers, process();

  const init = async () => {
    await updateLogs(chain, address, loading);
    transfers = contractEvents(chain, address, 'Transfer');
  }

  const process = () => {
    if ($transfers) {
      const balances = {};
      let loadingId = loading.init('Processing transfers', $transfers.length);
      for (const log of $transfers) {
        const wallets = Object.keys(balances);
        const from = log.args.from.value;
        const to = log.args.to.value;
        const amount = log.args.value.value;
        if (!wallets.includes(from)) {
          balances[from] = BigInt(0);
        }
        if (!wallets.includes(to)) {
          balances[to] = BigInt(0);
        }
        balances[from] += (amount * BigInt(-1));
        balances[to] += amount;
        loading.inc(loadingId);
      }
      loading.reset(loadingId);
      const stats = [];
      loadingId = loading.init('Processing balances', Object.entries(balances).length);
      for (const [ wallet, amount ] of Object.entries(balances)) {
        if (wallet !== '0x0000000000000000000000000000000000000000') {
          stats.push({ wallet, amount });
        }
        loading.inc(loadingId);
      }
      loading.reset(loadingId);
      data = stats;
    }
  }

  onMount(init);
</script>

{#if data}
  <Stats { data } { pieConf } { columns }>
    <i class="fa-regular fa-copy" slot="copiable"></i>
  </Stats>
{:else}
  Loading...
{/if}